.csatButtons {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
